import { createGlobalStyle } from 'styled-components';
import { breakpoints } from './Variables';

const GlobalStyles = createGlobalStyle`
  :root {
    --black: #000000;
    --orange: #EF7501;
    --green: #005948;
    --grey: #D6D0C2; // Use for Property
    --offWhite: #FFF4E1;
    --peach: #FCDEC1;
    --tan: #BEAA96;
    --tanLight: #E6DED0;
    --brown: #80796D;
    --lightBlue: #B0BDC7;
    // 12 column grid
    --col1: 8.33%;
    --col1Internal: 9.996%;
    --col2: 16.66%;
    --col3: 25%;
    --col4: 33.33%;
    --col5: 41.66%;
    --col6: 50%;
    --col7: 58.33%;
    --col8: 66.66%;
    --col9: 75%;
    --col10: 83.33%;
    --col11: 91.66%;
    --col12: 100%;
    // Other
    --navHeight: 3rem;
    --maxPageWidth: 1150px;
    // Font sizes
    --fsHome: 46px;
    --fsBody: 16px;
    --fsHero: 95px;
    --fsTitle1: 40px;
    --fsTitle2: 28px;
    --fsTitle3: 22px;
    --fsQuote: 22px;
    --fsButton: 14px;
    --fsFooterTitle: 15px;
    --fsFooterBody: 10px;
    --fsDetails: 11px;

    @media (min-width: ${breakpoints.breakLg}) {
      --fsTitle1: 65px;
      --fsTitle2: 31px;
      --fsTitle3: 26px;
      --fsQuote: 26px;
      --navHeight: 5rem;
    }
  }

  * {
    box-sizing: border-box;
  }

  html,
  body {
    margin: 0;
    padding: 0;
    font-size: var(--fsBody);
    line-height: 1.25;
  }

  body {
    &.expanded {
      overflow: hidden;
    }
    &.expanded:not(.nav) {
      nav {
        display: none;
      }
    }
  }

  .mobileHidden {
    @media (max-width: ${breakpoints.breakLg}) {
      display: none !important;
    }
  }

  .gatsby-image-wrapper img[src*=base64\\,] {
    image-rendering: -moz-crisp-edges;
    image-rendering: pixelated;
  }

  img {
    max-width: 100%;
  }

  h2 {
    font-size: var(--fsTitle2);
  }
  h3, h4 {
    font-size: var(--fsTitle3);
  }

  a {
    text-decoration: none;
    color: var(--black);
    transition: color 0.5s, border-color 0.5s, background-color 0.5s;

    &[disabled] {
      pointer-events: none;
      opacity: 0.5;
    }
  }

  .legend {
    .title {
      text-transform: uppercase;
    }
  }

  .small {
    font-size: 0.8em;
  }

  /* Buttons */
  button,
  .button {
    display: inline-block;
    border-radius: 2em;
    border-width: 1px;
    border-style: solid;
    padding: 0.25em 0.75em;
    background-color: transparent;
    cursor: pointer;
    transition: color 0.5s, border-color 0.5s, background-color 0.5s;

    &.cta {
      padding: 0.5em 1em;
    }
  }

  // General grid stuff
  section {
    padding: 0 var(--col1) 2rem var(--col1);

    & > *:first-child {
      margin-top: 0
    }
  }

  .upperCase {
    text-transform: uppercase;
  }
`;

export default GlobalStyles;
